// BL621 Phase 3 (Decision 042 §"Mode 4 — Debug") — the `debug` group.
//
// Developer-tooling primitives that used to be scattered top-level. Per
// Decision 042 the group is hidden from the default `--help` (registered with
// `{ hidden: true }` in index.ts) so the everyday surface stays small; it still
// shows under `--help` for the group itself and in `--help all`.
//
//   grid debug call <target> <path>   plain request to an entity's public URL
//   grid debug ssh  <entity-slug>     shell into a named entity

import { Command } from 'commander';
import { callCommand } from '../call.js';
import { debugSshCommand } from './ssh.js';

export const debugCommand = new Command('debug')
  .description('Developer debug tooling (hidden from the default help)')
  .addCommand(callCommand)
  .addCommand(debugSshCommand);
